<template>
  <div class="searchFilter" :gutter="10" style="display: flex; flex-wrap: wrap">
    <slot></slot>
    <el-form-item except >
      <el-button type="primary" @click="handleQuery">查询</el-button>
      <el-button @click="handleReset">重置</el-button>
      <el-button type="primary" @click="handleExport" v-show="showExport" >导出订单</el-button>
      <el-button type="primary" @click="handleExportDetail" v-show="showExportDetail" >导出订单详情</el-button>
      <el-button v-show="collapsiable" type="text" @click="shiftCollapsiable" class="operate">
        <span>
          {{ fold ? '收起' : '展开' }}&nbsp;
        </span>
        <i :class="fold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </el-button>
    </el-form-item>
  </div>
</template>
<script>
// import { Form, FormItem, Button } from 'element-ui'
export default {
  name: 'RtSearchFilter',
  // components: { Form, FormItem, Button },
  props: {
    // 最大展示数，默认3个，超过则隐藏，为0时不限制
    maxShow: {
      type: Number,
      default: 3,
    },
    // labelWidth: {
    //   type: String,
    //   default: '100px',
    // },
    // size: {
    //   type: String,
    //   default: 'small',
    // },

    // 新增：控制导出按钮显隐的 props
    showExport: {
      type: Boolean,
      default: true,  // 默认显示，可按需修改
    },
    showExportDetail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      collapsiable: false,
      fold: false,
    }
  },
  mounted() {
    // 通过最大显示个数控制展开/折叠
    this.$nextTick(() => {
      if (this.maxShow > 0) {
        this.minShowCtrol()
      }
    })
  },
  methods: {
    shiftCollapsiable() {
      this.fold = !this.fold;
      this.minShowCtrol();
      this.$nextTick(() => {
        this.$emit("getSearchHeight")
      });
    },
    // 通过maxShow控制元素显示/折叠
    minShowCtrol() {
      const group = document.querySelectorAll(`.searchFilter .el-form-item:not([except])`)
      const len = group.length ? group.length : 0
      if (this.maxShow < len) {
        group.forEach((item, index) => {
          if (index > this.maxShow - 1 && index < len) {
            item.hidden = !this.fold
          }
        })

        this.collapsiable = true
      } else {
        this.collapsiable = false
      }
    },
    handleQuery() {
      this.$emit('search')
    },
    handleReset() {
      this.$emit('reset')
    },
    handleExport() {
      this.$emit('export')
    },
    handleExportDetail() {
      this.$emit('exportDetail')
    }
  },
}
</script>
<style lang="scss">
.searchFilter {
  .el-button--text.operate {
    padding: 0 !important;
    color: #333 !important;
    > span {
      display: flex;
      align-items: center;
    }
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?d5217296